export const MARKS = { heading: "\u2061", action: "\u2062", character: "\u2063", dialogue: "\u2064", paren: "\u200C", transition: "\u200D" };
const BY_MARK = Object.fromEntries(Object.entries(MARKS).map(([k, v]) => [v, k]));
export const isScript = (mode) => mode === "screenplay" || mode === "stage";

export const TYPES = {
  screenplay: [["heading", "Scene heading", "INT. TAVERN - NIGHT"], ["action", "Action", "What we see"], ["character", "Character", "NAME"], ["paren", "Parenthetical", "(quietly)"], ["dialogue", "Dialogue", "What they say"], ["transition", "Transition", "CUT TO:"]],
  stage: [["heading", "Act / scene", "ACT ONE, SCENE 1"], ["action", "Stage direction", "Lights rise on…"], ["character", "Character", "NAME"], ["paren", "Direction in a line", "(aside)"], ["dialogue", "Dialogue", "What they say"]],
};

export const typeOf = (text) => BY_MARK[(text || "")[0]] || null;

const NEXT = { heading: "action", action: "action", character: "dialogue", paren: "dialogue", dialogue: "action", transition: "heading" };
export const nextType = (prev) => (prev ? NEXT[prev] : "heading");

export const cycle = (mode, t, step = 1) => { const l = TYPES[mode].map((x) => x[0]); return l[(l.indexOf(t) + step + l.length) % l.length]; };
